import React from "react";
import {
  CircleCheck,
  Info,
  Loader2,
  AlertCircle,
  TriangleAlert,
} from "lucide-react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

/**
 * Toasts open one gap BELOW the shell header (sweep A-67). The header is h-16 and
 * holds the Sous Chef button, the help link and the notification bell on the
 * right; at Sonner's default offset a toast sat on top of all three for as long
 * as it lived. The bottom right is not free either: the bug reporter owns it.
 */
const SHELL_HEADER_HEIGHT_PX = 64;
const TOAST_GAP_PX = 16;
export const TOAST_TOP_OFFSET = SHELL_HEADER_HEIGHT_PX + TOAST_GAP_PX;

const Toaster = ({ position = "top-right", ...props }: ToasterProps) => {
  return (
    <Sonner
      position={position}
      offset={{ top: TOAST_TOP_OFFSET, right: TOAST_GAP_PX }}
      mobileOffset={{ top: TOAST_TOP_OFFSET, right: TOAST_GAP_PX, left: TOAST_GAP_PX }}
      className="toaster group"
      closeButton
      icons={{
        success: <CircleCheck className="size-4" />,
        info: <Info className="size-4" />,
        warning: <TriangleAlert className="size-4" />,
        error: <AlertCircle className="size-4" />,
        loading: <Loader2 className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "hsl(var(--popover))",
          "--normal-text": "hsl(var(--popover-foreground))",
          "--normal-border": "hsl(var(--border))",
          "--success-bg": "#0fa852",
          "--success-text": "#ffffff",
          "--success-border": "#0d8f46",
          "--error-bg": "#b91c1c",
          "--error-text": "#ffffff",
          "--error-border": "#991b1b",
          "--warning-bg": "#fff8ed",
          "--warning-text": "#7d2b0a",
          "--warning-border": "#ffa038",
          "--info-bg": "#3b82f6",
          "--info-text": "#ffffff",
          "--info-border": "#2563eb",
          "--border-radius": "calc(var(--radius) - 2px)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster }
